(ns minorodata.components.pipeline-editor.details.core
  (:require
   [minorodata.components.pipeline-editor.details.analytics-models :refer [analytics-model-details]]
   [minorodata.components.pipeline-editor.details.extracts :refer [extract-details]]
   [minorodata.components.pipeline-editor.details.table :refer [table-details]]
   [minorodata.components.pipeline-editor.details.transform :refer [transform-details]]))

(defn details [{:keys [selected]}]
  (case (:type selected)
    "transform"
    [transform-details {:selected selected}]
    "table"
    [:f> table-details {:selected selected}]
    "extract"
    [extract-details {:selected selected}]
    "model"
    [:f> analytics-model-details {:selected selected}]
    nil))
